<sh-generic-overview
    [searchBarMode]="searchBarMode"
    [paginatedResults]="paginatedResults$ | async"
    [isLoading]="isLoading$ | async"
    [columns]="columns$ | async"
    [displayMode]="DEFAULT_DISPLAY_MODE"
    [allowSort]="allowSort"
    [showViewToggle]="showViewToggle"
    [availableSelect]="true"
    [selectedItems]="[]"
    [noItemsSelectedLabelKey]="'general.none-selected.other'"
    [itemsSelectedLabelKey]="'general.xx-selected.other'"
    [xxResultsLabelKey]="'general.xx-results.other'"
    [noResultsLabelKey]="'general.no-results.other'"
    [resultsPerPageOptions]="resultsPerPageOptions"
    (paginationInfoChanged)="onPaginationChange($event)"
    (itemsChecked)="onItemsChecked($event)"
></sh-generic-overview>
